/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export type paths = {
  '/admin/applications': {
    delete?: never;
    get?: never;
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    /**
     * Submit manual application
     * @description Submits a complete paper application and creates the customer's account. Idempotent per idempotencyKey in the body: a repeated request returns the original result, or resumes an attempt that did not finish.
     *
     *
     *
     *     ## Authorization
     *     `hasAuthority('deposits:manual-applications:write')`
     */
    post: operations['submit'];
    put?: never;
    trace?: never;
  };
  '/admin/applications/{id}': {
    delete?: never;
    /**
     * Fetch manual application
     * @description Fetches an application entered by customer care
     *
     *
     *
     *     ## Authorization
     *     `hasAnyAuthority('deposits:manual-applications:read', 'deposits:manual-applications:write')`
     */
    get: operations['get_2'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  '/admin/applications/initiate': {
    delete?: never;
    get?: never;
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    /**
     * Initiate manual application
     * @description Returns the products customer care may enroll manually in the market and the KYC survey to enter the paper answers against. Nothing is persisted.
     *
     *
     *
     *     ## Authorization
     *     `hasAuthority('deposits:manual-applications:write')`
     */
    post: operations['initiate_1'];
    put?: never;
    trace?: never;
  };
  '/applications': {
    delete?: never;
    /**
     * Fetch applications
     * @description Fetch applications
     *
     *
     *
     *     ## Authorization
     *     `isAuthenticated()`
     */
    get: operations['getAll_1'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    /**
     * Initiate application
     * @description Initialize application. If application already exists for customer, application id is returned instead
     *
     *
     *
     *     ## Authorization
     *     `isAuthenticated()`
     */
    post: operations['initiate'];
    put?: never;
    trace?: never;
  };
  '/applications/{id}': {
    delete?: never;
    /**
     * Fetch Application
     * @description Fetch application
     *
     *
     *
     *     ## Authorization
     *     `isAuthenticated()`
     */
    get: operations['get_1'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    /**
     * Save Application
     * @description Save application
     *
     *
     *
     *     ## Authorization
     *     `isAuthenticated()`
     */
    put: operations['save'];
    trace?: never;
  };
  '/applications/{id}/deposit_funds': {
    delete?: never;
    get?: never;
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    /**
     * Deposit funds
     * @description Deposit funds
     *
     *
     *
     *     ## Authorization
     *     `isAuthenticated()`
     */
    post: operations['depositFunds'];
    put?: never;
    trace?: never;
  };
  '/applications/{id}/deposit_information': {
    delete?: never;
    /**
     * Fetch deposit information
     * @description Fetch deposit information
     *
     *
     *
     *     ## Authorization
     *     `isAuthenticated()`
     */
    get: operations['depositInfo_1'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  '/applications/{id}/deposit-information': {
    delete?: never;
    /**
     * Fetch deposit information
     * @description Fetch deposit information
     *
     *
     *
     *     ## Authorization
     *     `isAuthenticated()`
     */
    get: operations['depositInfo'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  '/applications/{id}/reset': {
    delete?: never;
    get?: never;
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    /**
     * Reset application
     * @description Reset an existing application to allow starting over. All data associated with the application will be deleted and a new application will be created. If application does not exist, 404 is returned.
     *
     *
     *
     *     ## Authorization
     *     `isAuthenticated()`
     */
    put: operations['reset'];
    trace?: never;
  };
  '/applications/{id}/sign': {
    delete?: never;
    get?: never;
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    /**
     * Initiate application signing
     * @description Initiate application signing
     *
     *
     *
     *     ## Authorization
     *     `isAuthenticated()`
     */
    post: operations['initiateSigning'];
    put?: never;
    trace?: never;
  };
  '/applications/{id}/submit': {
    delete?: never;
    get?: never;
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    /**
     * Submit Application
     * @description Submit completed application
     *
     *
     *
     *     ## Authorization
     *     `isAuthenticated()`
     */
    post: operations['submit_1'];
    put?: never;
    trace?: never;
  };
  '/applications/sign/callback': {
    delete?: never;
    get?: never;
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    /**
     * Sign callback
     * @description Callback from digital-id-service after successful signing
     *
     *
     *
     *     ## Authorization
     *     `hasAuthority('signing:callback:write')`
     */
    post: operations['callback'];
    put?: never;
    trace?: never;
  };
  '/bban/bank_name': {
    delete?: never;
    get?: never;
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    /**
     * Lookup bank name
     * @description ## Authorization
     *     `isAuthenticated()`
     */
    put: operations['lookupBankName'];
    trace?: never;
  };
  '/bban/validate': {
    delete?: never;
    get?: never;
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    /**
     * Validate BBAN
     * @description ## Authorization
     *     `isAuthenticated()`
     */
    put: operations['validateBban'];
    trace?: never;
  };
  '/documents/deposit_account_common_terms/{product_code}': {
    delete?: never;
    /**
     * Get deposit account common terms document based on supplied product code
     * @description ## Authorization
     *     `isAuthenticated()`
     */
    get: operations['depositAccountCommonTerms'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  '/documents/deposit_account_info/{product_code}': {
    delete?: never;
    /**
     * Get deposit account information document based on supplied product code
     * @description ## Authorization
     *     `isAuthenticated()`
     */
    get: operations['accountInfo'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  '/documents/deposit_autogiro_terms': {
    delete?: never;
    /**
     * Get deposit autogiro terms document. Only available for Sweden (SE).
     * @description ## Authorization
     *     `isAuthenticated()`
     */
    get: operations['depositAutogiroTerms'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  '/documents/deposit_guarantee': {
    delete?: never;
    /**
     * Get deposit guarantee document for a specific country and language
     * @description ## Authorization
     *     `isAuthenticated()`
     */
    get: operations['depositGuarantee'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  '/kyc/countries': {
    delete?: never;
    /**
     * Get all countries for KYC survey
     * @description ## Authorization
     *     `isAuthenticated()`
     */
    get: operations['getCountries'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  '/pending_applications': {
    delete?: never;
    /**
     * Fetch pending applications
     * @description Fetch pending applications
     *
     *
     *
     *     ## Authorization
     *     `hasAuthority('deposits:pending-applications:read')`
     */
    get: operations['getAll'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
  '/pending_applications/{id}': {
    /**
     * Delete pending application
     * @description Delete pending application
     *
     *
     *
     *     ## Authorization
     *     `hasAuthority('deposits:pending-applications:write')`
     */
    delete: operations['delete'];
    /**
     * Fetch pending application
     * @description Fetch pending application
     *
     *
     *
     *     ## Authorization
     *     `hasAuthority('deposits:pending-applications:read')`
     */
    get: operations['getApplication'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    /**
     * Update pending application
     * @description Update pending application
     *
     *
     *
     *     ## Authorization
     *     `hasAuthority('deposits:pending-applications:write')`
     */
    put: operations['update'];
    trace?: never;
  };
  '/pending_applications/{id}/comments': {
    delete?: never;
    get?: never;
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    /**
     * Add comment to pending application
     * @description ## Authorization
     *     `hasAuthority('deposits:pending-applications:write')`
     */
    post: operations['addComment'];
    put?: never;
    trace?: never;
  };
  '/pending_applications/{id}/manager': {
    delete?: never;
    get?: never;
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    /**
     * Assign case manager to pending application
     * @description ## Authorization
     *     `hasAuthority('deposits:pending-applications:write')`
     */
    post: operations['assign'];
    put?: never;
    trace?: never;
  };
  '/phone_number/mobile/validate': {
    delete?: never;
    get?: never;
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    /**
     * Validate mobile phone number
     * @description ## Authorization
     *     `isAuthenticated()`
     */
    put: operations['validateMobilePhoneNumber'];
    trace?: never;
  };
  '/products': {
    delete?: never;
    /**
     * Fetch available products
     * @description Fetch available products
     *
     *
     *
     *     ## Authorization
     *     `permitAll()`
     */
    get: operations['get'];
    head?: never;
    options?: never;
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    patch?: never;
    post?: never;
    put?: never;
    trace?: never;
  };
};
export type webhooks = Record<string, never>;
export type components = {
  headers: never;
  parameters: never;
  pathItems: never;
  requestBodies: never;
  responses: never;
  schemas: {
    /** @description Add case comment request */
    AddCaseCommentRequest: {
      authorName?: string;
      comment?: string;
    };
    AmlScreenRejectedResponse: {
      /** @example 412 */
      code?: string;
      /** @example Precondition Failed */
      message?: string;
      /**
       * @description Timestamp of when error occurred.
       * @example 2019-11-21T09:52:34.678
       */
      timestamp?: string;
      /**
       * @description Unique id for this request.
       * @example 033c6a06-1d2c-498f-81a0-02b5f8aac79e
       */
      traceId?: string;
    };
    /** @description Application data */
    Application: {
      autogiroSettings?: components['schemas']['AutogiroSettings'];
      bankruptcyDetails?: components['schemas']['BankruptcyDetails'];
      /**
       * @description Campaign code used when creating the application
       * @example abc123
       */
      campaignCode?: string;
      /** @description Consents answers */
      consents?: components['schemas']['ConsentViewRequestDTO'][];
      /**
       * @description Deposit guarantee has been accepted
       * @example true
       */
      depositGuaranteeAccepted: boolean;
      disbursementAccount?: components['schemas']['DisbursementAccount'];
      /**
       * @description Customer email address
       * @example kalle.karlsson@resurs.se
       */
      email?: string;
      kycAnswers?: components['schemas']['JsonNode'];
      /** @description Customer phone numbers. Either home phone number or phoneNumber phone number must be given. */
      phoneNumber?: string;
      /**
       * @description Product code of chosen deposit product
       * @example abc123
       */
      productCode?: string;
      /**
       * @description Terms and conditions has been accepted
       * @example true
       */
      termsConditionsAccepted: boolean;
    };
    /** @description Application data, only provided if application already exists for customer */
    ApplicationDetailsResponseDTO: {
      autogiroSettings?: components['schemas']['AutogiroSettings'];
      bankruptcyDetails?: components['schemas']['BankruptcyDetails'];
      /**
       * @description Campaign code used when creating the application
       * @example abc123
       */
      campaignCode?: string;
      /** @description List of consents for this application */
      consents?: components['schemas']['ConsentViewDTO'][];
      /**
       * @description Deposit guarantee has been accepted
       * @example true
       */
      depositGuaranteeAccepted: boolean;
      disbursementAccount?: components['schemas']['DisbursementAccount'];
      /**
       * Format: email
       * @description Customer email address
       * @example kalle.karlsson@resurs.se
       */
      email?: string;
      /**
       * @description Interest rate for the product this application is based on. Missing if product code is not sent, guaranteed to be present otherwise
       * @example 3.85
       */
      interestRate?: number;
      interestType?: components['schemas']['InterestRateType'];
      kycAnswers?: components['schemas']['JsonNode'];
      /** @description Customer phone numbers. Either home phone number or phoneNumber phone number must be given. */
      phoneNumber?: string;
      /**
       * @description Product code of chosen deposit product
       * @example abc123
       */
      productCode?: string;
      status: components['schemas']['ApplicationStatus'];
      /**
       * @description Term duration for the account that this application is onboarding. Applicable only for fixed-rate products in Mambu
       * @example P3M
       */
      term?: string;
      /**
       * @description Terms and conditions has been accepted
       * @example true
       */
      termsConditionsAccepted: boolean;
    };
    /** @description Know your customer survey and answers */
    ApplicationKycResponse: {
      /**
       * @description Answers to the question
       * @example [
       *       "Answer 1",
       *       "Answer 2"
       *     ]
       */
      answers?: string[];
      /**
       * Format: int32
       * @description Unique identifier for a survey question
       * @example 100
       */
      id?: number;
      /**
       * @description Natural language of the question
       * @example Example question
       */
      question?: string;
    };
    ApplicationResponse: {
      _links: components['schemas']['OnboardingLinks'];
      application: components['schemas']['ApplicationDetailsResponseDTO'];
      kycSurvey: components['schemas']['JsonNode'];
      /**
       * @description KYC version. If no version is specified for the survey, 'NA'
       * @example V4
       */
      kycVersion: string;
    };
    ApplicationsListResponse: {
      application: components['schemas']['ApplicationDetailsResponseDTO'];
    };
    /**
     * @description Application status
     * @enum {string}
     */
    ApplicationStatus: ApplicationStatus;
    /** @description Assign case request */
    AssignCaseRequest: {
      caseManager: string;
    };
    /** @description Autogiro settings */
    AutogiroSettings: {
      /**
       * @description Bank account number
       * @example 987654321
       */
      accountNumber: string;
      /**
       * @description Account prefix number (also known as bank code, clearing number etc). Minimum length is 4 characters.
       * @example 1234
       */
      accountPrefix: string;
      withdrawalAmount: components['schemas']['MonetaryAmount'];
      /**
       * Format: int32
       * @description Withdrawal day of month
       * @example 26
       */
      withdrawalDate: number;
    };
    /** @description Bankruptcy details */
    BankruptcyDetails: {
      /** @description Name of assigned trustee for bankruptcy process. Mandatory if `declaredBankruptcy` is `true`. */
      bankruptcyTrustee?: string;
      /** @description Contact information of assigned trustee for bankruptcy process. Mandatory if `declaredBankruptcy` is `true`. */
      bankruptcyTrusteeContactInformation?: string;
      /**
       * @description Is customer in a current bankruptcy process. Mandatory for Norway.
       * @example true
       */
      declaredBankruptcy: boolean;
    };
    BbanBankNameRequest: {
      /**
       * @description Account prefix number (also known as bank code, clearing number etc). Minimum length is 4 characters.
       * @example 1234
       */
      accountPrefix: string;
      /**
       * @description Country code of the bank account.
       * @example NO
       * @enum {string}
       */
      countryCode: BbanBankNameRequestCountryCode;
    };
    BbanBankNameResponse: {
      /**
       * @description Name of the bank
       * @example Nordea
       */
      bankName: string;
    };
    BbanValidationRequest: {
      /**
       * @description Account number. Required in all markets.
       * @example 1234567890
       */
      accountNumber: string;
      /**
       * @description Account prefix number (also known as bank code, clearing number etc). Required in some markets (Sweden).
       * @example 1234
       */
      accountPrefix?: string;
      /**
       * @description Country code of the bank account.
       * @example SE
       * @enum {string}
       */
      countryCode: BbanValidationRequestCountryCode;
    };
    BlockedResponse: {
      /** @example 500 */
      code?: string;
      /** @example Internal Server Error */
      message?: string;
      /**
       * @description Timestamp of when error occurred.
       * @example 2019-11-21T09:52:34.678
       */
      timestamp?: string;
      /**
       * @description Unique id for this request.
       * @example 033c6a06-1d2c-498f-81a0-02b5f8aac79e
       */
      traceId?: string;
    };
    /** @description Comments related to the case, sorted by creation date in descending order i.e. most recent comment first. */
    CaseComment: {
      /**
       * @description Name of the author of the comment
       * @example John Doe
       */
      author: string;
      /**
       * @description Content of the comment
       * @example This is a comment on the case.
       */
      comment?: string;
      /**
       * Format: date-time
       * @description Timestamp when the comment was created, including timezone
       * @example 2025-04-10T09:00:00Z
       */
      created?: string;
    };
    /** @description Configuration rules describing how interest is calculated for this product */
    ConfigurationRule: {
      /**
       * Format: uuid
       * @description Unique identifier of the configuration rule
       */
      id?: string;
      interestCalculationType?: components['schemas']['InterestCalculationType'];
      periodType?: components['schemas']['PeriodType'];
      /**
       * @description The term duration this rule applies to, when periodType is TERM
       * @example P3M
       */
      term?: string;
      tiers?: components['schemas']['InterestRateTiers'];
    };
    ConsentDataDTO: {
      /** Format: int32 */
      displayOrder?: number;
      /**
       * Format: uuid
       * @description Unique identifier for the consent data
       * @example a154021d-0753-4023-af41-d2d316e44817
       */
      id: string;
      /** @enum {string} */
      proposalType?: ConsentDataDTOProposalType;
      /** @enum {string} */
      status?: ConsentDataDTOStatus;
      texts?: string[];
      /** @enum {string} */
      type?: ConsentDataDTOType;
    };
    /** @description Set of consent data proposals */
    ConsentDataRequestDTO: {
      /**
       * Format: uuid
       * @description Unique identifier for the consent data
       * @example a154021d-0753-4023-af41-d2d316e44817
       */
      id: string;
      /**
       * @description Status of the consent data
       * @enum {string}
       */
      status: ConsentDataRequestDTOStatus;
    };
    /** @description List of consents for this application */
    ConsentViewDTO: {
      data?: components['schemas']['ConsentDataDTO'][];
      /**
       * Format: uuid
       * @description Unique identifier for the consent view
       * @example 6f302f24-064d-4ac3-b826-cb3e5de8b419
       */
      id: string;
      key?: string;
      name?: string;
    };
    /** @description Consent details */
    ConsentViewRequestDTO: {
      /**
       * Format: uuid
       * @description Unique identifier for the consent view
       * @example 6f302f24-064d-4ac3-b826-cb3e5de8b419
       */
      id: string;
      /** @description Set of consent data proposals */
      proposals: components['schemas']['ConsentDataRequestDTO'][];
    };
    CountryNotImplementedResponse: {
      /** @example 400 */
      code?: string;
      /** @example Country not implemented: FO */
      message?: string;
      /**
       * @description Timestamp of when error occurred.
       * @example 2019-11-21T09:52:34.678
       */
      timestamp?: string;
      /**
       * @description Unique id for this request.
       * @example 033c6a06-1d2c-498f-81a0-02b5f8aac79e
       */
      traceId?: string;
    };
    /** @description List of countries */
    CountryTranslationResponseDTO: {
      code?: string;
      translations?: {
        [key: string]: string;
      };
    };
    DataBuffer: Record<string, never>;
    /** @description Context to pass to underlying banking implementation */
    DepositFundsContextDTO: {
      /**
       * Format: uri
       * @description URI where the user should be redirected to after the operation is completed
       * @example https://resursbank.se
       */
      redirectUrl: string;
    };
    DepositFundsRequestDTO: {
      amount: components['schemas']['MonetaryAmount'];
      context: components['schemas']['DepositFundsContextDTO'];
      /** @description Text to show on transaction */
      transactionText?: string;
    };
    DepositFundsResponseDTO: {
      _links?: components['schemas']['DepositFundsResponseLinks'];
    };
    /** @description Links for depositing funds into an account */
    DepositFundsResponseLinks: {
      'openbanking-redirect'?: components['schemas']['HALLink'];
    };
    DepositInfoResponse: {
      /**
       * @description Channel account number or BBAN account number to be used for deposit
       * @example 99887766
       */
      accountNumber?: string;
      /**
       * @description Account prefix number (ex clearing number)
       * @example 1234
       */
      accountPrefix?: string;
      /**
       * @deprecated
       * @description KID number. Deprecated, use reference instead
       * @example 12345670112345
       */
      kid?: string;
      /**
       * @description Payment reference. For example KID in Norway and FIK in Denmark.
       * @example string
       */
      reference?: string;
    };
    /** @description Products that may be enrolled manually in the market, sorted by name. Customer-specific eligibility, such as product boundaries, is checked on submit. */
    DepositProduct: {
      /**
       * @description Internal code of product
       * @example abc123
       */
      code: string;
      /** @description Configuration rules describing how interest is calculated for this product */
      configurationRules?: components['schemas']['ConfigurationRule'][];
      /** @description Short description of product */
      description: string;
      interest?: components['schemas']['Interest'];
      interestType: components['schemas']['InterestRateType'];
      /**
       * @description Name of product
       * @example Fasträntekonto 12 månader
       */
      name: string;
      productLink: components['schemas']['HALLink'];
    };
    /** @description Disbursement account details */
    DisbursementAccount: {
      accountNumber?: string;
      accountPrefix?: string;
    };
    ErrorResponse: {
      /**
       * @description Http error code
       * @example 400
       */
      code: string;
      /**
       * @description Message describing the error
       * @example Validation error
       */
      message: string;
      /**
       * @description Timestamp of when error occurred.
       * @example 2019-11-21T09:52:34.678
       */
      timestamp: string;
      /**
       * @description Unique id for this request.
       * @example 033c6a06-1d2c-498f-81a0-02b5f8aac79e
       */
      traceId: string;
    };
    /** @description Customer government ID */
    GovernmentIdDTO: {
      /**
       * @description Country code of the government ID, iso 3166-1 alpha-2 format
       * @enum {string}
       */
      countryCode?: GovernmentIdDTOCountryCode;
      /** @description The government ID of the customer */
      governmentId?: string;
    };
    /** @description A link to autogiro terms for deposit account. */
    HALLink: {
      /** @enum {string} */
      access?: HALLinkAccess;
      /** Format: uri */
      href?: string;
    };
    /** @description Initial application data */
    InitApplicationRequestDTO: {
      /** @description Campaign code */
      campaignCode?: string;
      /**
       * Format: uuid
       * @description Configuration rule ID. Required for product codes that do not define an interest rate on the product level
       * @example 123e4567-e89b-12d3-a456-426614174000
       */
      configurationRuleId?: string;
      /** @description Product code */
      productCode: string;
    };
    InitApplicationResponse: {
      _links: components['schemas']['OnboardingLinks'];
      /**
       * Format: uuid
       * @description Application Id
       */
      applicationId: string;
      /** @description List of consents for this application */
      consents?: components['schemas']['ConsentViewDTO'][];
      kycSurvey: components['schemas']['JsonNode'];
      /**
       * @description KYC version. If no version is specified for the survey, 'NA'
       * @example V4
       */
      kycVersion: string;
      /**
       * @description Terms and conditions has been accepted
       * @example true
       */
      termsConditionsAccepted: boolean;
    };
    InitiateConflictResponse: {
      /**
       * Format: uuid
       * @description Application id
       * @example 88d9ec14-15e1-4d66-ab67-5448de64a69c
       */
      applicationId: string;
      /** @example 409 */
      code?: string;
      /** @example Application already exists */
      message?: string;
      resumable?: boolean;
      /**
       * @description Timestamp of when error occurred.
       * @example 2019-11-21T09:52:34.678
       */
      timestamp?: string;
      /**
       * @description Unique id for this request.
       * @example 033c6a06-1d2c-498f-81a0-02b5f8aac79e
       */
      traceId?: string;
    };
    /** @description Interest settings of product. Only present if the product code represents one and only one interest rate */
    Interest: {
      /**
       * @description Interest rate
       * @example 3.85
       */
      rate: number;
      type: components['schemas']['InterestRateType'];
    };
    /**
     * @description How interest is calculated for this rule
     * @enum {string}
     */
    InterestCalculationType: InterestCalculationType;
    /** @description The thresholds for this tier */
    InterestRateTier: {
      /** @description Lower bound of the threshold */
      lowerBound?: number;
      /**
       * @description Interest rate
       * @example 3.85
       */
      rate?: number;
      /** @description Upper bound of the threshold */
      upperBound?: number;
    };
    /** @description Interest rate tiers for this rule */
    InterestRateTiers: {
      /** @description The thresholds for this tier */
      thresholds?: components['schemas']['InterestRateTier'][];
      type?: components['schemas']['InterestRateTierType'];
    };
    /**
     * @description Type of interest rate tiering
     * @enum {string}
     */
    InterestRateTierType: InterestRateTierType;
    /**
     * @description Type of interest rate for the chosen product
     * @example VARIABLE
     * @enum {string}
     */
    InterestRateType: InterestRateType;
    InvalidApplicationStatusResponse: {
      /** @example 400 */
      code?: string;
      /** @example Invalid application status */
      message?: string;
      /**
       * @description Timestamp of when error occurred.
       * @example 2019-11-21T09:52:34.678
       */
      timestamp?: string;
      /**
       * @description Unique id for this request.
       * @example 033c6a06-1d2c-498f-81a0-02b5f8aac79e
       */
      traceId?: string;
    };
    InvalidConfigurationRuleResponse: {
      /**
       * @description Http error code
       * @example 400
       */
      code: string;
      /**
       * @description Message describing the error
       * @example Validation error
       */
      message: string;
      /**
       * @description Timestamp of when error occurred.
       * @example 2019-11-21T09:52:34.678
       */
      timestamp: string;
      /**
       * @description Unique id for this request.
       * @example 033c6a06-1d2c-498f-81a0-02b5f8aac79e
       */
      traceId: string;
      /** @description List of validation errors */
      validationErrors?: components['schemas']['ValidationError'][];
    };
    /** @description List of question for customer to answer */
    JsonNode: Record<string, never>;
    KycCountriesListResponseDTO: {
      /** @description List of countries */
      countries: components['schemas']['CountryTranslationResponseDTO'][];
    };
    Link: {
      deprecation?: string;
      href?: string;
      hreflang?: string;
      name?: string;
      profile?: string;
      templated?: boolean;
      title?: string;
      type?: string;
    };
    Links: {
      [key: string]: components['schemas']['Link'];
    };
    /** @description The created account, present once the account is created */
    ManualAccountInformation: {
      /** @description Key of the created deposit account */
      depositAccountKey: string;
      /** @description Payment reference for deposits to the account */
      paymentReference?: string;
    };
    /** @description Customer address. Required unless the address is protected. */
    ManualAddress: {
      /**
       * @description City
       * @example Oslo
       */
      city: string;
      /**
       * @description Country
       * @example NO
       * @enum {string}
       */
      country: ManualAddressCountry;
      /**
       * @description Postal code
       * @example 0155
       */
      postalCode: string;
      /**
       * @description Street and number
       * @example Storgata 1
       */
      street: string;
    };
    ManualApplicationRequest: {
      attestation: components['schemas']['ManualAttestation'];
      bankruptcyDetails?: components['schemas']['BankruptcyDetails'];
      /**
       * Format: uuid
       * @description Configuration rule ID. Required for product codes that do not define an interest rate on the product level
       * @example 123e4567-e89b-12d3-a456-426614174000
       */
      configurationRuleId?: string;
      customer: components['schemas']['ManualCustomer'];
      disbursementAccount?: components['schemas']['DisbursementAccount'];
      /**
       * @description Client generated key, the same for every retry of the same submit (a UUID is recommended). A repeated request with the same key returns the original result, or resumes an attempt that did not finish.
       * @example 3f2b8c1e-5d4a-4e7b-9c6f-1a2b3c4d5e6f
       */
      idempotencyKey: string;
      kyc: components['schemas']['ManualKyc'];
      /**
       * @description Code of one of the products returned by initiate
       * @example DA_BUFFER_CURRENT_NO_01
       */
      productCode: string;
    };
    ManualApplicationResponse: {
      accountInformation?: components['schemas']['ManualAccountInformation'];
      /**
       * Format: uuid
       * @description Application id
       */
      applicationId: string;
      manualEntry: components['schemas']['ManualEntry'];
      status: components['schemas']['ApplicationStatus'];
    };
    /** @description The agent's attestation of the signed paper application */
    ManualAttestation: {
      /**
       * @description The paper application accepts the deposit guarantee information
       * @example true
       */
      depositGuaranteeAccepted: boolean;
      /**
       * Format: date
       * @description Date Resurs received the paper application
       * @example 2026-10-01
       */
      documentReceivedDate: string;
      /**
       * Format: date
       * @description Date the customer signed the paper application
       * @example 2026-09-28
       */
      documentSignedDate: string;
      /**
       * @description The paper application accepts the terms and conditions
       * @example true
       */
      termsConditionsAccepted: boolean;
    };
    ManualCustomer: {
      address?: components['schemas']['ManualAddress'];
      /**
       * @description Market of the application
       * @example NO
       * @enum {string}
       */
      countryCode: ManualCustomerCountryCode;
      /**
       * @description Email address
       * @example kari.nordmann@example.com
       */
      email: string;
      /**
       * @description First name
       * @example Kari
       */
      firstName: string;
      /**
       * @description Customer government id
       * @example 01017012345
       */
      governmentId: string;
      /**
       * @description Customer language
       * @example NO
       * @enum {string}
       */
      language: ManualCustomerLanguage;
      /**
       * @description Last name
       * @example Nordmann
       */
      lastName: string;
      /**
       * @description Mobile phone number
       * @example 41234567
       */
      phoneNumber: string;
      /**
       * @description Whether the customer has a protected address. The address must then be absent.
       * @example false
       */
      protectedAddress: boolean;
    };
    /** @description Manual-entry audit details */
    ManualEntry: {
      /**
       * @description The agent who entered the application
       * @example agent@resurs.se
       */
      agentId: string;
      /**
       * Format: date
       * @description Date Resurs received the paper application
       */
      documentReceivedDate: string;
      /**
       * Format: date
       * @description Date the customer signed the paper application
       */
      documentSignedDate: string;
      /**
       * Format: date-time
       * @description When the application was submitted
       */
      submittedAt: string;
    };
    ManualInitiateRequest: {
      /**
       * @description Market of the paper application
       * @example NO
       * @enum {string}
       */
      countryCode: ManualInitiateRequestCountryCode;
    };
    ManualInitiateResponse: {
      /**
       * @description Market of the paper application
       * @example NO
       * @enum {string}
       */
      countryCode: ManualInitiateResponseCountryCode;
      kycSurvey: components['schemas']['ManualKycSurvey'];
      /** @description Products that may be enrolled manually in the market, sorted by name. Customer-specific eligibility, such as product boundaries, is checked on submit. */
      products: components['schemas']['DepositProduct'][];
    };
    ManualKyc: {
      answers: components['schemas']['JsonNode'];
      /**
       * Format: int32
       * @description Template version from initiate, sent back unchanged
       * @example 3
       */
      templateVersion?: number;
      /**
       * @description KYC version from initiate, sent back unchanged
       * @example V4
       */
      version?: string;
    };
    /** @description KYC survey to enter the paper answers against */
    ManualKycSurvey: {
      survey: components['schemas']['JsonNode'];
      /**
       * Format: int32
       * @description Template version of a template-based survey. Send back unchanged on submit.
       * @example 3
       */
      templateVersion?: number;
      /**
       * @description KYC version tag, absent for the legacy survey. Send back unchanged on submit.
       * @example V4
       */
      version?: string;
    };
    MonetaryAmount: {
      /** @example 99.96 */
      amount?: number;
      /** @example USD */
      currency?: string;
    };
    NotOldEnoughResponse: {
      /** @example 451 */
      code?: string;
      /** @example Unavailable For Legal Reasons */
      message?: string;
      /**
       * @description Timestamp of when error occurred.
       * @example 2019-11-21T09:52:34.678
       */
      timestamp?: string;
      /**
       * @description Unique id for this request.
       * @example 033c6a06-1d2c-498f-81a0-02b5f8aac79e
       */
      traceId?: string;
    };
    /** @description Collection of hyperlinks */
    OnboardingLinks: {
      apply_deposit_account: components['schemas']['HALLink'];
      autogiro_terms?: components['schemas']['HALLink'];
      common_terms_deposit_account: components['schemas']['HALLink'];
      deposit_guarantee: components['schemas']['HALLink'];
    };
    /** @description Details about why this application is pending */
    PendingApplicationDetailsDTO: {
      /**
       * @description Name of user who approved/rejected case, only exists on applications which have passed manual inspection
       * @example John Doe
       */
      authorizedBy?: string;
      /**
       * @description Name of assigned trustee for bankruptcy process.
       * @example Kalle Lojer
       */
      bankruptcyTrustee?: string;
      /**
       * @description Email of assigned trustee for bankruptcy process.
       * @example <EMAIL>
       */
      bankruptcyTrusteeEmail?: string;
      /** @description Comments related to the case, sorted by creation date in descending order i.e. most recent comment first. */
      caseComments?: components['schemas']['CaseComment'][];
      /**
       * @description Case manager
       * @example Jane Smith
       */
      caseManager?: string;
      /**
       * @description If the customer is in personal bankruptcy process
       * @example true
       */
      declaredBankruptcy?: boolean;
      /**
       * @description If the AML process resulted in an error or not
       * @example true
       */
      error?: boolean;
      /**
       * @description If the customer requires extra due diligence due to e.g having selected pep or a high-risk country during KYC
       * @example true
       */
      extraDueDiligence?: boolean;
      /**
       * @description If the AML process resulted in a positive match for PEP or not
       * @example true
       */
      pep?: boolean;
      /**
       * @description If the customer has either a protected identity or protected address
       * @example true
       */
      protectedIdentityOrAddress?: boolean;
      /**
       * @description If the AML process resulted in a positive match for sanction or not
       * @example true
       */
      sanction?: boolean;
    };
    PendingApplicationResponse: {
      /**
       * Format: uuid
       * @description Unique identifier
       * @example ceeb6bed-51d8-4482-995f-3aad52d9e304
       */
      applicationId?: string;
      /**
       * @description Country code
       * @example SE
       * @enum {string}
       */
      countryCode?: PendingApplicationResponseCountryCode;
      /**
       * Format: date-time
       * @description Time of creation
       * @example 2020-01-01T00:00:00Z
       */
      created?: string;
      /**
       * @description Deposit guarantee has been accepted
       * @example true
       */
      depositGuaranteeAccepted?: boolean;
      /**
       * Format: email
       * @description Customer email address
       * @example kalle.karlsson@resurs.se
       */
      email?: string;
      /** @description Error, specified if the application is corrupt or otherwise in an invalid state */
      error?: string;
      /**
       * @description Customer first name
       * @example Kalle
       */
      firstName?: string;
      governmentId?: components['schemas']['GovernmentIdDTO'];
      /** @description Know your customer survey and answers */
      kyc?: components['schemas']['ApplicationKycResponse'][];
      /**
       * @description Customer last name
       * @example Karlsson
       */
      lastName?: string;
      pendingApplicationDetails?: components['schemas']['PendingApplicationDetailsDTO'];
      /** @description Customer phone numbers. Either home phone number or phoneNumber phone number must be given. */
      phoneNumber?: string;
      /**
       * @description Product code of chosen deposit product
       * @example abc123
       */
      productCode?: string;
      /**
       * @description Status of application
       * @example APPROVED
       * @enum {string}
       */
      status?: PendingApplicationResponseStatus;
      /**
       * @description Terms and conditions has been accepted
       * @example true
       */
      termsConditionsAccepted?: boolean;
      /**
       * Format: date-time
       * @description Time of last update
       * @example 2021-01-01T00:00:00Z
       */
      updated?: string;
    };
    /**
     * @description The period this rule applies to
     * @enum {string}
     */
    PeriodType: PeriodType;
    PhoneNumberValidationRequest: {
      /**
       * Format: int32
       * @description Country code of the phone number.
       * @example 46
       */
      countryCode: number;
      /**
       * Format: int64
       * @description Phone number.
       * @example 701234567
       */
      phoneNumber: number;
    };
    /** @description The boundary that was exceeded. */
    ProductBoundary: {
      /** @enum {string} */
      type?: ProductBoundaryType;
      /** Format: int32 */
      value?: number;
    };
    ProductBoundaryExceededResponse: {
      boundary: components['schemas']['ProductBoundary'];
      /**
       * @description Http error code
       * @example 400
       */
      code: string;
      /**
       * @description Message describing the error
       * @example Validation error
       */
      message: string;
      /**
       * @description Timestamp of when error occurred.
       * @example 2019-11-21T09:52:34.678
       */
      timestamp: string;
      /**
       * @description Unique id for this request.
       * @example 033c6a06-1d2c-498f-81a0-02b5f8aac79e
       */
      traceId: string;
    };
    ProductNotFoundResponse: {
      /**
       * @description Http error code
       * @example 400
       */
      code: string;
      /**
       * @description Message describing the error
       * @example Validation error
       */
      message: string;
      /**
       * @description Timestamp of when error occurred.
       * @example 2019-11-21T09:52:34.678
       */
      timestamp: string;
      /**
       * @description Unique id for this request.
       * @example 033c6a06-1d2c-498f-81a0-02b5f8aac79e
       */
      traceId: string;
      /** @description List of validation errors */
      validationErrors?: components['schemas']['ValidationError'][];
    };
    SignApplicationRequest: {
      /**
       * @description URI where the user should be redirected to after cancelled signing
       * @example https://resurs.com/cancelled
       */
      onCancelledUri: string;
      /**
       * @description URI where the user should be redirected to after successful signing
       * @example https://resurs.com/success
       */
      onSuccessUri: string;
    };
    SignApplicationResponse: {
      _links: components['schemas']['Links'];
      status: components['schemas']['ApplicationStatus'];
    };
    SigningCallbackRequest: {
      /** @description A base64 encoded payload */
      payload: string;
    };
    SubmitApplicationRequest: {
      autogiroSettings?: components['schemas']['AutogiroSettings'];
      bankruptcyDetails?: components['schemas']['BankruptcyDetails'];
      /**
       * @description Campaign code used when creating the application
       * @example abc123
       */
      campaignCode?: string;
      /** @description Consent details */
      consents?: components['schemas']['ConsentViewRequestDTO'][];
      /**
       * @description Deposit guarantee has been accepted
       * @example true
       */
      depositGuaranteeAccepted: boolean;
      disbursementAccount?: components['schemas']['DisbursementAccount'];
      /**
       * @description Customer email address
       * @example kalle.karlsson@resurs.se
       */
      email: string;
      kycAnswers: components['schemas']['JsonNode'];
      /**
       * @description URI where the user should be redirected to after cancelled signing
       * @example https://resurs.com/cancelled
       */
      onCancelledUri: string;
      /**
       * @description URI where the user should be redirected to after successful signing
       * @example https://resurs.com/success
       */
      onSuccessUri: string;
      /** @description Customer phone numbers. Either home phone number or phoneNumber phone number must be given. */
      phoneNumber: string;
      /**
       * @description Product code of chosen deposit product
       * @example abc123
       */
      productCode: string;
      /**
       * @description Terms and conditions has been accepted
       * @example true
       */
      termsConditionsAccepted: boolean;
    };
    SubmitApplicationResponse: {
      _links: components['schemas']['Links'];
      status: components['schemas']['ApplicationStatus'];
    };
    /** @description Update application data */
    UpdatePendingApplication: {
      /**
       * @description Name of user who approve/rejects case
       * @example John Doe
       */
      authorizedBy: string;
      /**
       * @description Status of application
       * @example APPROVED
       * @enum {string}
       */
      status: UpdatePendingApplicationStatus;
    };
    /** @description List of validation errors */
    ValidationError: {
      /**
       * @description Name of offending field in payload.
       * @example email
       */
      fieldName: string;
      /**
       * @description Message describing the validation error.
       * @example Email address must contain '@' character.
       */
      message: string;
    };
    ValidationErrorResponse: {
      /**
       * @description Http error code
       * @example 400
       */
      code: string;
      /**
       * @description Message describing the error
       * @example Validation error
       */
      message: string;
      /**
       * @description Timestamp of when error occurred.
       * @example 2019-11-21T09:52:34.678
       */
      timestamp: string;
      /**
       * @description Unique id for this request.
       * @example 033c6a06-1d2c-498f-81a0-02b5f8aac79e
       */
      traceId: string;
      /** @description List of validation errors */
      validationErrors?: components['schemas']['ValidationError'][];
    };
  };
};
export type BlockedResponse = components['schemas']['BlockedResponse'];
export type ErrorResponse = components['schemas']['ErrorResponse'];
export type CountryNotImplementedResponse =
  components['schemas']['CountryNotImplementedResponse'];
export type InitiateConflictResponse =
  components['schemas']['InitiateConflictResponse'];
export type NotOldEnoughResponse =
  components['schemas']['NotOldEnoughResponse'];
export type ProductNotFoundResponse =
  components['schemas']['ProductNotFoundResponse'];
export type ValidationError = components['schemas']['ValidationError'];
export type InvalidConfigurationRuleResponse =
  components['schemas']['InvalidConfigurationRuleResponse'];
export type InvalidApplicationStatusResponse =
  components['schemas']['InvalidApplicationStatusResponse'];
export type ValidationErrorResponse =
  components['schemas']['ValidationErrorResponse'];
export type ApplicationKycResponse =
  components['schemas']['ApplicationKycResponse'];
export type CaseComment = components['schemas']['CaseComment'];
export type GovernmentIdDTO = components['schemas']['GovernmentIdDTO'];
export type PendingApplicationDetailsDTO =
  components['schemas']['PendingApplicationDetailsDTO'];
export type PendingApplicationResponse =
  components['schemas']['PendingApplicationResponse'];
export type SignApplicationRequest =
  components['schemas']['SignApplicationRequest'];
export type HALLink = components['schemas']['HALLink'];
export type Links = components['schemas']['Links'];
export type SignApplicationResponse =
  components['schemas']['SignApplicationResponse'];
export type CountryTranslationResponseDTO =
  components['schemas']['CountryTranslationResponseDTO'];
export type KycCountriesListResponseDTO =
  components['schemas']['KycCountriesListResponseDTO'];
export type BankruptcyDetails = components['schemas']['BankruptcyDetails'];
export type DisbursementAccount = components['schemas']['DisbursementAccount'];
export type JsonNode = components['schemas']['JsonNode'];
export type ManualAddress = components['schemas']['ManualAddress'];
export type ManualApplicationRequest =
  components['schemas']['ManualApplicationRequest'];
export type ManualAttestation = components['schemas']['ManualAttestation'];
export type ManualCustomer = components['schemas']['ManualCustomer'];
export type ManualKyc = components['schemas']['ManualKyc'];
export type ManualAccountInformation =
  components['schemas']['ManualAccountInformation'];
export type ManualApplicationResponse =
  components['schemas']['ManualApplicationResponse'];
export type ManualEntry = components['schemas']['ManualEntry'];
export type UpdatePendingApplication =
  components['schemas']['UpdatePendingApplication'];
export type ApplicationDetailsResponseDTO =
  components['schemas']['ApplicationDetailsResponseDTO'];
export type ApplicationsListResponse =
  components['schemas']['ApplicationsListResponse'];
export type AutogiroSettings = components['schemas']['AutogiroSettings'];
export type ConsentDataDTO = components['schemas']['ConsentDataDTO'];
export type ConsentViewDTO = components['schemas']['ConsentViewDTO'];
export type MonetaryAmount = components['schemas']['MonetaryAmount'];
export type ConfigurationRule = components['schemas']['ConfigurationRule'];
export type DepositProduct = components['schemas']['DepositProduct'];
export type Interest = components['schemas']['Interest'];
export type InterestRateTier = components['schemas']['InterestRateTier'];
export type InterestRateTiers = components['schemas']['InterestRateTiers'];
export type DepositInfoResponse = components['schemas']['DepositInfoResponse'];
export type ManualInitiateRequest =
  components['schemas']['ManualInitiateRequest'];
export type ManualInitiateResponse =
  components['schemas']['ManualInitiateResponse'];
export type ManualKycSurvey = components['schemas']['ManualKycSurvey'];
export type DataBuffer = components['schemas']['DataBuffer'];
export type InitApplicationRequestDTO =
  components['schemas']['InitApplicationRequestDTO'];
export type InitApplicationResponse =
  components['schemas']['InitApplicationResponse'];
export type OnboardingLinks = components['schemas']['OnboardingLinks'];
export type ProductBoundary = components['schemas']['ProductBoundary'];
export type ProductBoundaryExceededResponse =
  components['schemas']['ProductBoundaryExceededResponse'];
export type DepositFundsContextDTO =
  components['schemas']['DepositFundsContextDTO'];
export type DepositFundsRequestDTO =
  components['schemas']['DepositFundsRequestDTO'];
export type DepositFundsResponseDTO =
  components['schemas']['DepositFundsResponseDTO'];
export type DepositFundsResponseLinks =
  components['schemas']['DepositFundsResponseLinks'];
export type ApplicationResponse = components['schemas']['ApplicationResponse'];
export type BbanValidationRequest =
  components['schemas']['BbanValidationRequest'];
export type PhoneNumberValidationRequest =
  components['schemas']['PhoneNumberValidationRequest'];
export type ConsentDataRequestDTO =
  components['schemas']['ConsentDataRequestDTO'];
export type ConsentViewRequestDTO =
  components['schemas']['ConsentViewRequestDTO'];
export type SubmitApplicationRequest =
  components['schemas']['SubmitApplicationRequest'];
export type SubmitApplicationResponse =
  components['schemas']['SubmitApplicationResponse'];
export type AmlScreenRejectedResponse =
  components['schemas']['AmlScreenRejectedResponse'];
export type AssignCaseRequest = components['schemas']['AssignCaseRequest'];
export type SigningCallbackRequest =
  components['schemas']['SigningCallbackRequest'];
export type Application = components['schemas']['Application'];
export type AddCaseCommentRequest =
  components['schemas']['AddCaseCommentRequest'];
export type BbanBankNameRequest = components['schemas']['BbanBankNameRequest'];
export type BbanBankNameResponse =
  components['schemas']['BbanBankNameResponse'];
export type Link = components['schemas']['Link'];
export type $defs = Record<string, never>;
export type operations = {
  accountInfo: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        product_code: string;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        content: {
          'application/pdf': components['schemas']['DataBuffer'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          '*/*':
            | components['schemas']['CountryNotImplementedResponse']
            | components['schemas']['ErrorResponse']
            | components['schemas']['ProductNotFoundResponse']
            | components['schemas']['InvalidConfigurationRuleResponse']
            | components['schemas']['InvalidApplicationStatusResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Conflict */
      409: {
        content: {
          '*/*':
            | components['schemas']['ErrorResponse']
            | components['schemas']['InitiateConflictResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unprocessable Entity */
      422: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unavailable For Legal Reasons */
      451: {
        content: {
          '*/*': components['schemas']['NotOldEnoughResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          '*/*':
            | components['schemas']['ErrorResponse']
            | components['schemas']['BlockedResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  addComment: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /**
         * @description Pending application id
         * @example fd0d1ca3-af13-4f6a-8865-cf5c46fc172f
         */
        id: string;
      };
      query?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AddCaseCommentRequest'];
      };
    };
    responses: {
      /** @description OK */
      200: {
        content: {
          'application/json': components['schemas']['PendingApplicationResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Conflict */
      409: {
        content: {
          '*/*':
            | components['schemas']['ErrorResponse']
            | components['schemas']['InitiateConflictResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unprocessable Entity */
      422: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unavailable For Legal Reasons */
      451: {
        content: {
          '*/*': components['schemas']['NotOldEnoughResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  assign: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /**
         * @description Pending application id
         * @example fd0d1ca3-af13-4f6a-8865-cf5c46fc172f
         */
        id: string;
      };
      query?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AssignCaseRequest'];
      };
    };
    responses: {
      /** @description OK */
      200: {
        content: {
          'application/json': components['schemas']['PendingApplicationResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Conflict */
      409: {
        content: {
          '*/*':
            | components['schemas']['ErrorResponse']
            | components['schemas']['InitiateConflictResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unprocessable Entity */
      422: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unavailable For Legal Reasons */
      451: {
        content: {
          '*/*': components['schemas']['NotOldEnoughResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  callback: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SigningCallbackRequest'];
      };
    };
    responses: {
      /** @description Created */
      201: {
        content: {
          'application/json': boolean;
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Conflict */
      409: {
        content: {
          '*/*':
            | components['schemas']['ErrorResponse']
            | components['schemas']['InitiateConflictResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unprocessable Entity */
      422: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unavailable For Legal Reasons */
      451: {
        content: {
          '*/*': components['schemas']['NotOldEnoughResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  delete: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /**
         * @description Pending application id
         * @example fd0d1ca3-af13-4f6a-8865-cf5c46fc172f
         */
        id: string;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description No Content */
      204: {
        content?: never;
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Conflict */
      409: {
        content: {
          '*/*':
            | components['schemas']['ErrorResponse']
            | components['schemas']['InitiateConflictResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unprocessable Entity */
      422: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unavailable For Legal Reasons */
      451: {
        content: {
          '*/*': components['schemas']['NotOldEnoughResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  depositAccountCommonTerms: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        product_code: string;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        content: {
          'application/pdf': components['schemas']['DataBuffer'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          '*/*':
            | components['schemas']['CountryNotImplementedResponse']
            | components['schemas']['ErrorResponse']
            | components['schemas']['ProductNotFoundResponse']
            | components['schemas']['InvalidConfigurationRuleResponse']
            | components['schemas']['InvalidApplicationStatusResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Conflict */
      409: {
        content: {
          '*/*':
            | components['schemas']['ErrorResponse']
            | components['schemas']['InitiateConflictResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unprocessable Entity */
      422: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unavailable For Legal Reasons */
      451: {
        content: {
          '*/*': components['schemas']['NotOldEnoughResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          '*/*':
            | components['schemas']['ErrorResponse']
            | components['schemas']['BlockedResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  depositAutogiroTerms: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        content: {
          'application/pdf': components['schemas']['DataBuffer'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          '*/*':
            | components['schemas']['CountryNotImplementedResponse']
            | components['schemas']['ErrorResponse']
            | components['schemas']['ProductNotFoundResponse']
            | components['schemas']['InvalidConfigurationRuleResponse']
            | components['schemas']['InvalidApplicationStatusResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Conflict */
      409: {
        content: {
          '*/*':
            | components['schemas']['ErrorResponse']
            | components['schemas']['InitiateConflictResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unprocessable Entity */
      422: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unavailable For Legal Reasons */
      451: {
        content: {
          '*/*': components['schemas']['NotOldEnoughResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          '*/*':
            | components['schemas']['ErrorResponse']
            | components['schemas']['BlockedResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  depositFunds: {
    parameters: {
      cookie?: never;
      header?: {
        /** @description Natural language, defaults to official language for country */
        'Accept-Language'?: PathsApplicationsIdDeposit_fundsPostParametersHeaderAcceptLanguage;
      };
      path: {
        /**
         * @description Application id
         * @example fd0d1ca3-af13-4f6a-8865-cf5c46fc172f
         */
        id: string;
      };
      query?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['DepositFundsRequestDTO'];
      };
    };
    responses: {
      /** @description OK */
      200: {
        content: {
          'application/json': components['schemas']['DepositFundsResponseDTO'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Conflict */
      409: {
        content: {
          '*/*':
            | components['schemas']['ErrorResponse']
            | components['schemas']['InitiateConflictResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unprocessable Entity */
      422: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unavailable For Legal Reasons */
      451: {
        content: {
          '*/*': components['schemas']['NotOldEnoughResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  depositGuarantee: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        content: {
          'application/pdf': components['schemas']['DataBuffer'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          '*/*':
            | components['schemas']['CountryNotImplementedResponse']
            | components['schemas']['ErrorResponse']
            | components['schemas']['ProductNotFoundResponse']
            | components['schemas']['InvalidConfigurationRuleResponse']
            | components['schemas']['InvalidApplicationStatusResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Conflict */
      409: {
        content: {
          '*/*':
            | components['schemas']['ErrorResponse']
            | components['schemas']['InitiateConflictResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unprocessable Entity */
      422: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unavailable For Legal Reasons */
      451: {
        content: {
          '*/*': components['schemas']['NotOldEnoughResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          '*/*':
            | components['schemas']['ErrorResponse']
            | components['schemas']['BlockedResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  depositInfo: {
    parameters: {
      cookie?: never;
      header?: {
        /** @description Natural language, defaults to official language for country */
        'Accept-Language'?: PathsApplicationsIdDepositInformationGetParametersHeaderAcceptLanguage;
      };
      path: {
        /**
         * @description Application id
         * @example fd0d1ca3-af13-4f6a-8865-cf5c46fc172f
         */
        id: string;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        content: {
          'application/json': components['schemas']['DepositInfoResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Conflict */
      409: {
        content: {
          '*/*':
            | components['schemas']['ErrorResponse']
            | components['schemas']['InitiateConflictResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unprocessable Entity */
      422: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unavailable For Legal Reasons */
      451: {
        content: {
          '*/*': components['schemas']['NotOldEnoughResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Implemented */
      501: {
        content: {
          'application/json': components['schemas']['CountryNotImplementedResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  depositInfo_1: {
    parameters: {
      cookie?: never;
      header?: {
        /** @description Natural language, defaults to official language for country */
        'Accept-Language'?: PathsApplicationsIdDeposit_informationGetParametersHeaderAcceptLanguage;
      };
      path: {
        /**
         * @description Application id
         * @example fd0d1ca3-af13-4f6a-8865-cf5c46fc172f
         */
        id: string;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        content: {
          'application/json': components['schemas']['DepositInfoResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Conflict */
      409: {
        content: {
          '*/*':
            | components['schemas']['ErrorResponse']
            | components['schemas']['InitiateConflictResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unprocessable Entity */
      422: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unavailable For Legal Reasons */
      451: {
        content: {
          '*/*': components['schemas']['NotOldEnoughResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Implemented */
      501: {
        content: {
          'application/json': components['schemas']['CountryNotImplementedResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  get: {
    parameters: {
      cookie?: never;
      header?: {
        /** @description Natural language, defaults to official language for country */
        'Accept-Language'?: PathsProductsGetParametersHeaderAcceptLanguage;
      };
      path?: never;
      query: {
        country: PathsProductsGetParametersQueryCountry;
      };
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        content: {
          'application/json': components['schemas']['DepositProduct'][];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Conflict */
      409: {
        content: {
          '*/*':
            | components['schemas']['ErrorResponse']
            | components['schemas']['InitiateConflictResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unprocessable Entity */
      422: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unavailable For Legal Reasons */
      451: {
        content: {
          '*/*': components['schemas']['NotOldEnoughResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  get_1: {
    parameters: {
      cookie?: never;
      header?: {
        /** @description Natural language, defaults to official language for country */
        'Accept-Language'?: PathsApplicationsIdGetParametersHeaderAcceptLanguage;
      };
      path: {
        /**
         * @description Application id
         * @example fd0d1ca3-af13-4f6a-8865-cf5c46fc172f
         */
        id: string;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        content: {
          'application/json': components['schemas']['ApplicationResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Conflict */
      409: {
        content: {
          '*/*':
            | components['schemas']['ErrorResponse']
            | components['schemas']['InitiateConflictResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unprocessable Entity */
      422: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unavailable For Legal Reasons */
      451: {
        content: {
          '*/*': components['schemas']['NotOldEnoughResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Implemented */
      501: {
        content: {
          'application/json': components['schemas']['CountryNotImplementedResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  get_2: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /** @description Application id */
        id: string;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        content: {
          'application/json': components['schemas']['ManualApplicationResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Conflict */
      409: {
        content: {
          '*/*':
            | components['schemas']['ErrorResponse']
            | components['schemas']['InitiateConflictResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unprocessable Entity */
      422: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unavailable For Legal Reasons */
      451: {
        content: {
          '*/*': components['schemas']['NotOldEnoughResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  getAll: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        content: {
          'application/json': components['schemas']['PendingApplicationResponse'][];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Conflict */
      409: {
        content: {
          '*/*':
            | components['schemas']['ErrorResponse']
            | components['schemas']['InitiateConflictResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unprocessable Entity */
      422: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unavailable For Legal Reasons */
      451: {
        content: {
          '*/*': components['schemas']['NotOldEnoughResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  getAll_1: {
    parameters: {
      cookie?: never;
      header?: {
        /** @description Natural language, defaults to official language for country */
        'Accept-Language'?: PathsApplicationsGetParametersHeaderAcceptLanguage;
      };
      path?: never;
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        content: {
          'application/json': components['schemas']['ApplicationsListResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Conflict */
      409: {
        content: {
          '*/*':
            | components['schemas']['ErrorResponse']
            | components['schemas']['InitiateConflictResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unprocessable Entity */
      422: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unavailable For Legal Reasons */
      451: {
        content: {
          '*/*': components['schemas']['NotOldEnoughResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  getApplication: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /**
         * @description Pending application id
         * @example fd0d1ca3-af13-4f6a-8865-cf5c46fc172f
         */
        id: string;
      };
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        content: {
          'application/json': components['schemas']['PendingApplicationResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Conflict */
      409: {
        content: {
          '*/*':
            | components['schemas']['ErrorResponse']
            | components['schemas']['InitiateConflictResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unprocessable Entity */
      422: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unavailable For Legal Reasons */
      451: {
        content: {
          '*/*': components['schemas']['NotOldEnoughResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  getCountries: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        content: {
          'application/json': components['schemas']['KycCountriesListResponseDTO'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          '*/*':
            | components['schemas']['CountryNotImplementedResponse']
            | components['schemas']['ErrorResponse']
            | components['schemas']['ProductNotFoundResponse']
            | components['schemas']['InvalidConfigurationRuleResponse']
            | components['schemas']['InvalidApplicationStatusResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Conflict */
      409: {
        content: {
          '*/*':
            | components['schemas']['ErrorResponse']
            | components['schemas']['InitiateConflictResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unprocessable Entity */
      422: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unavailable For Legal Reasons */
      451: {
        content: {
          '*/*': components['schemas']['NotOldEnoughResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  initiate: {
    parameters: {
      cookie?: never;
      header?: {
        /** @description Natural language, defaults to official language for country */
        'Accept-Language'?: PathsApplicationsPostParametersHeaderAcceptLanguage;
      };
      path?: never;
      query?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['InitApplicationRequestDTO'];
      };
    };
    responses: {
      /** @description Created */
      201: {
        content: {
          'application/json': components['schemas']['InitApplicationResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      409: {
        content: {
          'application/json': components['schemas']['InitiateConflictResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      422: {
        content: {
          'application/json': components['schemas']['ProductBoundaryExceededResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      451: {
        content: {
          'application/json': components['schemas']['NotOldEnoughResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Implemented */
      501: {
        content: {
          'application/json': components['schemas']['CountryNotImplementedResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  initiate_1: {
    parameters: {
      cookie?: never;
      header?: {
        /** @description Natural language, defaults to official language for country */
        'Accept-Language'?: PathsAdminApplicationsInitiatePostParametersHeaderAcceptLanguage;
      };
      path?: never;
      query?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ManualInitiateRequest'];
      };
    };
    responses: {
      /** @description OK */
      200: {
        content: {
          'application/json': components['schemas']['ManualInitiateResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Conflict */
      409: {
        content: {
          '*/*':
            | components['schemas']['ErrorResponse']
            | components['schemas']['InitiateConflictResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unprocessable Entity */
      422: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unavailable For Legal Reasons */
      451: {
        content: {
          '*/*': components['schemas']['NotOldEnoughResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  initiateSigning: {
    parameters: {
      cookie?: never;
      header?: {
        /** @description Natural language, defaults to official language for country */
        'Accept-Language'?: PathsApplicationsIdSignPostParametersHeaderAcceptLanguage;
      };
      path: {
        /**
         * @description Application id
         * @example fd0d1ca3-af13-4f6a-8865-cf5c46fc172f
         */
        id: string;
      };
      query?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SignApplicationRequest'];
      };
    };
    responses: {
      /** @description OK */
      200: {
        content: {
          'application/json': components['schemas']['SignApplicationResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Conflict */
      409: {
        content: {
          '*/*':
            | components['schemas']['ErrorResponse']
            | components['schemas']['InitiateConflictResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unprocessable Entity */
      422: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unavailable For Legal Reasons */
      451: {
        content: {
          '*/*': components['schemas']['NotOldEnoughResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  lookupBankName: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BbanBankNameRequest'];
      };
    };
    responses: {
      /** @description Bank name found */
      200: {
        content: {
          'application/json': components['schemas']['BbanBankNameResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          '*/*':
            | components['schemas']['CountryNotImplementedResponse']
            | components['schemas']['ErrorResponse']
            | components['schemas']['ProductNotFoundResponse']
            | components['schemas']['InvalidConfigurationRuleResponse']
            | components['schemas']['InvalidApplicationStatusResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Conflict */
      409: {
        content: {
          '*/*':
            | components['schemas']['ErrorResponse']
            | components['schemas']['InitiateConflictResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unprocessable Entity */
      422: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unavailable For Legal Reasons */
      451: {
        content: {
          '*/*': components['schemas']['NotOldEnoughResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  reset: {
    parameters: {
      cookie?: never;
      header?: {
        /** @description Natural language, defaults to official language for country */
        'Accept-Language'?: PathsApplicationsIdResetPutParametersHeaderAcceptLanguage;
      };
      path: {
        /**
         * @description Application id
         * @example fd0d1ca3-af13-4f6a-8865-cf5c46fc172f
         */
        id: string;
      };
      query?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['InitApplicationRequestDTO'];
      };
    };
    responses: {
      /** @description OK */
      200: {
        content: {
          'application/json': components['schemas']['InitApplicationResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Conflict */
      409: {
        content: {
          '*/*':
            | components['schemas']['ErrorResponse']
            | components['schemas']['InitiateConflictResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unprocessable Entity */
      422: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unavailable For Legal Reasons */
      451: {
        content: {
          '*/*': components['schemas']['NotOldEnoughResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  save: {
    parameters: {
      cookie?: never;
      header?: {
        /** @description Natural language, defaults to official language for country */
        'Accept-Language'?: PathsApplicationsIdPutParametersHeaderAcceptLanguage;
      };
      path: {
        /**
         * @description Application id
         * @example fd0d1ca3-af13-4f6a-8865-cf5c46fc172f
         */
        id: string;
      };
      query?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['Application'];
      };
    };
    responses: {
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Conflict */
      409: {
        content: {
          '*/*':
            | components['schemas']['ErrorResponse']
            | components['schemas']['InitiateConflictResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unprocessable Entity */
      422: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unavailable For Legal Reasons */
      451: {
        content: {
          '*/*': components['schemas']['NotOldEnoughResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Implemented */
      501: {
        content: {
          'application/json': components['schemas']['CountryNotImplementedResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  submit: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ManualApplicationRequest'];
      };
    };
    responses: {
      /** @description Repeated request, original result */
      200: {
        content: {
          'application/json': components['schemas']['ManualApplicationResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Created */
      201: {
        content: {
          'application/json': components['schemas']['ManualApplicationResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description idempotencyKey reused with another payload, request in progress, or KYC survey outdated */
      409: {
        content: {
          '*/*':
            | components['schemas']['ErrorResponse']
            | components['schemas']['InitiateConflictResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Product boundary exceeded or product not eligible */
      422: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      451: {
        content: {
          'application/json': components['schemas']['NotOldEnoughResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  submit_1: {
    parameters: {
      cookie?: never;
      header?: {
        /** @description Natural language, defaults to official language for country */
        'Accept-Language'?: PathsApplicationsIdSubmitPostParametersHeaderAcceptLanguage;
      };
      path: {
        /**
         * @description Application id
         * @example fd0d1ca3-af13-4f6a-8865-cf5c46fc172f
         */
        id: string;
      };
      query?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SubmitApplicationRequest'];
      };
    };
    responses: {
      /** @description OK */
      200: {
        content: {
          'application/json': components['schemas']['SubmitApplicationResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Conflict */
      409: {
        content: {
          '*/*':
            | components['schemas']['ErrorResponse']
            | components['schemas']['InitiateConflictResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Precondition Failed */
      412: {
        content: {
          'application/json': components['schemas']['AmlScreenRejectedResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unprocessable Entity */
      422: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unavailable For Legal Reasons */
      451: {
        content: {
          '*/*': components['schemas']['NotOldEnoughResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Implemented */
      501: {
        content: {
          'application/json': components['schemas']['CountryNotImplementedResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  update: {
    parameters: {
      cookie?: never;
      header?: never;
      path: {
        /**
         * @description Pending application id
         * @example fd0d1ca3-af13-4f6a-8865-cf5c46fc172f
         */
        id: string;
      };
      query?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdatePendingApplication'];
      };
    };
    responses: {
      /** @description OK */
      200: {
        content: {
          'application/json': components['schemas']['PendingApplicationResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          'application/json': components['schemas']['ValidationErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Conflict */
      409: {
        content: {
          '*/*':
            | components['schemas']['ErrorResponse']
            | components['schemas']['InitiateConflictResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unprocessable Entity */
      422: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unavailable For Legal Reasons */
      451: {
        content: {
          '*/*': components['schemas']['NotOldEnoughResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  validateBban: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BbanValidationRequest'];
      };
    };
    responses: {
      /** @description BBAN is valid */
      200: {
        content?: never;
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          '*/*':
            | components['schemas']['CountryNotImplementedResponse']
            | components['schemas']['ErrorResponse']
            | components['schemas']['ProductNotFoundResponse']
            | components['schemas']['InvalidConfigurationRuleResponse']
            | components['schemas']['InvalidApplicationStatusResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Conflict */
      409: {
        content: {
          '*/*':
            | components['schemas']['ErrorResponse']
            | components['schemas']['InitiateConflictResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unprocessable Entity */
      422: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unavailable For Legal Reasons */
      451: {
        content: {
          '*/*': components['schemas']['NotOldEnoughResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
  validateMobilePhoneNumber: {
    parameters: {
      cookie?: never;
      header?: never;
      path?: never;
      query?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PhoneNumberValidationRequest'];
      };
    };
    responses: {
      /** @description OK */
      200: {
        content?: never;
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Bad Request */
      400: {
        content: {
          '*/*':
            | components['schemas']['CountryNotImplementedResponse']
            | components['schemas']['ErrorResponse']
            | components['schemas']['ProductNotFoundResponse']
            | components['schemas']['InvalidConfigurationRuleResponse']
            | components['schemas']['InvalidApplicationStatusResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unauthorized */
      401: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Forbidden */
      403: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Not Found */
      404: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Conflict */
      409: {
        content: {
          '*/*':
            | components['schemas']['ErrorResponse']
            | components['schemas']['InitiateConflictResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unprocessable Entity */
      422: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Unavailable For Legal Reasons */
      451: {
        content: {
          '*/*': components['schemas']['NotOldEnoughResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
      /** @description Internal Server Error */
      500: {
        content: {
          '*/*': components['schemas']['ErrorResponse'];
        };
        headers: {
          [name: string]: unknown;
        };
      };
    };
  };
};
export enum PathsApplicationsIdSignPostParametersHeaderAcceptLanguage {
  DA = 'DA',
  EN = 'EN',
  FI = 'FI',
  NO = 'NO',
  SV = 'SV',
  UNKNOWN = 'UNKNOWN',
}
export enum PathsApplicationsGetParametersHeaderAcceptLanguage {
  DA = 'DA',
  EN = 'EN',
  FI = 'FI',
  NO = 'NO',
  SV = 'SV',
  UNKNOWN = 'UNKNOWN',
}
export enum PathsApplicationsPostParametersHeaderAcceptLanguage {
  DA = 'DA',
  EN = 'EN',
  FI = 'FI',
  NO = 'NO',
  SV = 'SV',
  UNKNOWN = 'UNKNOWN',
}
export enum PathsProductsGetParametersQueryCountry {
  SE = 'SE',
  NO = 'NO',
  DK = 'DK',
  FI = 'FI',
  UNKNOWN = 'UNKNOWN',
}
export enum PathsProductsGetParametersHeaderAcceptLanguage {
  DA = 'DA',
  EN = 'EN',
  FI = 'FI',
  NO = 'NO',
  SV = 'SV',
  UNKNOWN = 'UNKNOWN',
}
export enum PathsApplicationsIdDepositInformationGetParametersHeaderAcceptLanguage {
  DA = 'DA',
  EN = 'EN',
  FI = 'FI',
  NO = 'NO',
  SV = 'SV',
  UNKNOWN = 'UNKNOWN',
}
export enum PathsApplicationsIdDeposit_informationGetParametersHeaderAcceptLanguage {
  DA = 'DA',
  EN = 'EN',
  FI = 'FI',
  NO = 'NO',
  SV = 'SV',
  UNKNOWN = 'UNKNOWN',
}
export enum PathsAdminApplicationsInitiatePostParametersHeaderAcceptLanguage {
  DA = 'DA',
  EN = 'EN',
  FI = 'FI',
  NO = 'NO',
  SV = 'SV',
  UNKNOWN = 'UNKNOWN',
}
export enum PathsApplicationsIdDeposit_fundsPostParametersHeaderAcceptLanguage {
  DA = 'DA',
  EN = 'EN',
  FI = 'FI',
  NO = 'NO',
  SV = 'SV',
  UNKNOWN = 'UNKNOWN',
}
export enum PathsApplicationsIdGetParametersHeaderAcceptLanguage {
  DA = 'DA',
  EN = 'EN',
  FI = 'FI',
  NO = 'NO',
  SV = 'SV',
  UNKNOWN = 'UNKNOWN',
}
export enum PathsApplicationsIdPutParametersHeaderAcceptLanguage {
  DA = 'DA',
  EN = 'EN',
  FI = 'FI',
  NO = 'NO',
  SV = 'SV',
  UNKNOWN = 'UNKNOWN',
}
export enum PathsApplicationsIdSubmitPostParametersHeaderAcceptLanguage {
  DA = 'DA',
  EN = 'EN',
  FI = 'FI',
  NO = 'NO',
  SV = 'SV',
  UNKNOWN = 'UNKNOWN',
}
export enum PathsApplicationsIdResetPutParametersHeaderAcceptLanguage {
  DA = 'DA',
  EN = 'EN',
  FI = 'FI',
  NO = 'NO',
  SV = 'SV',
  UNKNOWN = 'UNKNOWN',
}
export enum GovernmentIdDTOCountryCode {
  SE = 'SE',
  NO = 'NO',
  DK = 'DK',
  FI = 'FI',
  UNKNOWN = 'UNKNOWN',
}
export enum PendingApplicationResponseCountryCode {
  SE = 'SE',
  NO = 'NO',
  DK = 'DK',
  FI = 'FI',
  UNKNOWN = 'UNKNOWN',
}
export enum PendingApplicationResponseStatus {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
}
export enum ApplicationStatus {
  COMPLETED = 'COMPLETED',
  PENDING = 'PENDING',
  SENT_FOR_SIGNING = 'SENT_FOR_SIGNING',
  PROCESSING = 'PROCESSING',
  OK = 'OK',
  SIGNING_CANCELLED = 'SIGNING_CANCELLED',
  SIGNING_COMPLETED = 'SIGNING_COMPLETED',
  REJECTED = 'REJECTED',
  READY_FOR_SIGNING = 'READY_FOR_SIGNING',
  MANUAL_PROCESSING = 'MANUAL_PROCESSING',
}
export enum HALLinkAccess {
  PUBLIC = 'PUBLIC',
}
export enum ManualAddressCountry {
  SE = 'SE',
  NO = 'NO',
  DK = 'DK',
  FI = 'FI',
  UNKNOWN = 'UNKNOWN',
}
export enum ManualCustomerCountryCode {
  SE = 'SE',
  NO = 'NO',
  DK = 'DK',
  FI = 'FI',
  UNKNOWN = 'UNKNOWN',
}
export enum ManualCustomerLanguage {
  DA = 'DA',
  EN = 'EN',
  FI = 'FI',
  NO = 'NO',
  SV = 'SV',
  UNKNOWN = 'UNKNOWN',
}
export enum UpdatePendingApplicationStatus {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
}
export enum ConsentDataDTOType {
  TEXT = 'TEXT',
  CONSENT = 'CONSENT',
}
export enum ConsentDataDTOProposalType {
  OPT_IN = 'OPT_IN',
  OPT_OUT = 'OPT_OUT',
  SOFT_OPT_IN = 'SOFT_OPT_IN',
}
export enum ConsentDataDTOStatus {
  NONE = 'NONE',
  OBTAINED = 'OBTAINED',
  REVOKED = 'REVOKED',
}
export enum InterestRateType {
  VARIABLE = 'VARIABLE',
  FIXED = 'FIXED',
}
export enum InterestCalculationType {
  FLAT = 'FLAT',
  TIERED = 'TIERED',
}
export enum InterestRateTierType {
  BRACKET = 'BRACKET',
  LEVEL = 'LEVEL',
}
export enum PeriodType {
  UNBOUNDED = 'UNBOUNDED',
  TERM = 'TERM',
}
export enum ManualInitiateRequestCountryCode {
  SE = 'SE',
  NO = 'NO',
  DK = 'DK',
  FI = 'FI',
  UNKNOWN = 'UNKNOWN',
}
export enum ManualInitiateResponseCountryCode {
  SE = 'SE',
  NO = 'NO',
  DK = 'DK',
  FI = 'FI',
  UNKNOWN = 'UNKNOWN',
}
export enum ProductBoundaryType {
  WITHDRAWALS_PER_YEAR = 'WITHDRAWALS_PER_YEAR',
  WITHDRAWAL_DELAY = 'WITHDRAWAL_DELAY',
  MAX_ACCOUNTS = 'MAX_ACCOUNTS',
}
export enum BbanValidationRequestCountryCode {
  SE = 'SE',
  NO = 'NO',
  DK = 'DK',
  FI = 'FI',
  UNKNOWN = 'UNKNOWN',
}
export enum ConsentDataRequestDTOStatus {
  OBTAINED = 'OBTAINED',
  REVOKED = 'REVOKED',
  NONE = 'NONE',
}
export enum BbanBankNameRequestCountryCode {
  SE = 'SE',
  NO = 'NO',
  DK = 'DK',
  FI = 'FI',
  UNKNOWN = 'UNKNOWN',
}
